import { render, staticRenderFns } from "./sideNav.vue?vue&type=template&id=248447e5&scoped=true&"
import script from "./sideNav.vue?vue&type=script&lang=js&"
export * from "./sideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248447e5",
  null
  
)

export default component.exports